import { render } from "./PreorderVariantModal.vue?vue&type=template&id=34a2fe96&scoped=true"
import script from "./PreorderVariantModal.vue?vue&type=script&lang=js"
export * from "./PreorderVariantModal.vue?vue&type=script&lang=js"

import "./PreorderVariantModal.vue?vue&type=style&index=0&id=34a2fe96&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a2fe96"]])

export default __exports__